<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 10:44:10
 * @LastEditors: lau
 * @LastEditTime: 2022-08-23 15:17:38
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 10:18:24
 * @LastEditors: lau
 * @LastEditTime: 2022-08-22 10:21:03
-->
<!-- 获取车辆身份 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
            },
            responseCode: {
                "data": {
                    },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台预约/取消预约月票",
                t_url: this.commonUrls.test+"bookOrCancelReservation",
                p_url: this.commonUrls.prod+"bookOrCancelReservation",
                precondition: "无",
                fitSystem: "云停车场,传统VEMS车场,路边车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthId', info2: '是', info3: 'Long', info4: '月票类型ID' },
                        { info1: 'carCode', info2: '是', info3: 'Long', info4: '车牌号码' },
                        { info1: 'reservationId', info2: '否', info3: 'Long', info4: '月票预约记录id(取消预约必填)' },
                        { info1: 'userId', info2: '是', info3: 'Long', info4: '预约用户id' },
                        { info1: 'type', info2: '是', info3: 'Long', info4: '0预约，1取消预约' },
                        { info1: 'source', info2: '否', info3: 'Integer', info4: '预约来源1第三方0智泊云平台' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'reservationId', info2: '是', info3: 'Long', info4: '月票预约记录id' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/bookOrCancelReservation.vue